<template>
  <div>
    <va-input :value="orderInfo.id" label="Номер заказа" disabled />
    <va-input
      :value="
        orderInfo.delivery_type === 'pickup'
          ? 'Самовывоз'
          : orderInfo.delivery_type === 'delivery'
          ? 'Доставка'
          : '—'
      "
      label="Тип получения"
      disabled
    />
    <template v-if="orderInfo.created_at">
      <va-input
        :value="formatOmskDateTime(orderInfo.created_at)"
        label="Дата создания заказа"
        disabled
      />
    </template>
    <va-input
      :value="
        (orderInfo.processed_by && orderInfo.processed_by.name) || '—'
      "
      label="Обработал заказ"
      disabled
    />
    <div class="mb-3">
      <h5 class="mb-2">Покупатель</h5>
      <va-input
        :value="orderInfo.customer_name || orderInfo.name"
        label="Имя покупателя"
        disabled
      />
      <va-input
        :value="orderInfo.customer_phone || orderInfo.phone"
        label="Телефон покупателя"
        disabled
        class="mt-2"
      />
    </div>
    <template v-if="orderInfo.recipient_name || orderInfo.recipient_phone">
      <div class="mb-3">
        <h5 class="mb-2">Контакты получателя</h5>
        <va-input
          :value="orderInfo.recipient_name || '—'"
          label="Имя получателя"
          disabled
        />
        <va-input
          :value="orderInfo.recipient_phone || '—'"
          label="Номер телефона получателя"
          disabled
          class="mt-2"
        />
      </div>
    </template>
    <template v-if="orderInfo.delivery_type === 'pickup'">
      <va-input
        :value="
          (orderInfo.pickup_location && orderInfo.pickup_location.address) ||
          orderInfo.pickup_address ||
          'Самовывоз'
        "
        label="Адрес самовывоза"
        disabled
      />
      <template v-if="orderInfo.date_delivery">
        <va-input
          :value="formatPreviewDate(orderInfo.date_delivery)"
          label="Дата самовывоза"
          disabled
        />
      </template>
    </template>
    <template v-else-if="orderInfo.delivery_type === 'delivery'">
      <va-input
        :value="orderInfo.full_address || '—'"
        label="Адрес доставки"
        disabled
      />
      <template v-if="orderInfo.date_delivery">
        <va-input
          :value="formatPreviewDate(orderInfo.date_delivery)"
          label="Дата доставки"
          disabled
        />
      </template>
      <template v-if="orderInfo.time_delivery_from">
        <va-input
          :value="
            orderInfo.time_delivery_from +
            (orderInfo.time_delivery_to &&
            orderInfo.time_delivery_to !== orderInfo.time_delivery_from
              ? ' - ' + orderInfo.time_delivery_to
              : '')
          "
          label="Время доставки"
          disabled
        />
      </template>
      <template v-if="orderInfo.delivery_mode_label">
        <va-input
          :value="orderInfo.delivery_mode_label"
          label="Режим доставки"
          disabled
        />
      </template>
      <template v-if="orderInfo.photo_required">
        <va-input value="Да" label="Фото при доставке" disabled />
      </template>
    </template>
    <template v-if="orderInfo.card_text">
      <va-input
        :value="orderInfo.card_text"
        label="Текст открытки"
        type="textarea"
        disabled
        class="mt-3"
      />
    </template>
    <template v-if="orderComment">
      <va-input
        :value="orderComment"
        label="Комментарий к заказу"
        type="textarea"
        disabled
        class="mt-3"
      />
    </template>
    <template v-if="staffComment">
      <va-input
        :value="staffComment"
        label="Комментарий к заказу для персонала"
        type="textarea"
        disabled
        class="mt-3"
      />
    </template>
    <template v-if="orderInfo.do_not_call">
      <va-input value="Да" label="Не звонить мне" disabled />
    </template>
    <template v-else>
      <!-- Fallback для старых заказов без delivery_type -->
      <template
        v-if="
          orderInfo.full_address === null && orderInfo.date_delivery !== null
        "
      >
        <va-input value="Самовывоз" label="Адрес доставки" disabled />
      </template>
      <template v-else-if="orderInfo.full_address">
        <va-input
          :value="orderInfo.full_address"
          label="Адрес доставки"
          disabled
        />
      </template>
    </template>
    <!-- Сумма без скидки -->
    <va-input
      :value="formatPrice(totalBefore)"
      label="Сумма без скидки"
      disabled
    />
    <!-- Размер скидки (если есть) -->
    <va-input
      v-if="hasDiscount"
      :value="formatPrice(discountAmount)"
      label="Размер скидки"
      disabled
    />
    <!-- Сумма со скидкой -->
    <va-input
      :value="formatPrice(totalAfter)"
      label="Сумма со скидкой"
      disabled
      class="total-after-input"
    />
    <template v-if="hasDimensionalStatus">
      <div class="order-status-blocks mb-2">
        <h5 class="order-status-blocks__heading">Статус заказа</h5>
        <va-input :value="fulfillmentSummary" label="Этап исполнения" disabled />
      </div>
      <div class="order-status-blocks">
        <h5 class="order-status-blocks__heading">Статус оплаты</h5>
        <va-input :value="paymentSummary" label="Оплата" disabled />
      </div>
    </template>
    <va-input
      v-else-if="orderInfo.status"
      :value="orderStatus"
      label="Статус"
      disabled
    />
    <div
      v-if="orderInfo.products && orderInfo.products.length > 0"
      class="mt-4"
    >
      <h3 class="mb-3">Товары заказа</h3>
      <va-data-table
        :fields="productFields"
        :data="orderInfo.products"
        class="va-table"
      >
        <template slot="product_name" slot-scope="props">
          <span>{{
            props.rowData.name ||
            (props.rowData.product && props.rowData.product.name) ||
            "—"
          }}</span>
        </template>
        <template slot="qty" slot-scope="props">
          <span>{{ props.rowData.qty }}</span>
        </template>
        <template slot="components" slot-scope="props">
          <ul
            v-if="getProductComponents(props.rowData).length > 0"
            class="components-list"
          >
            <li
              v-for="(componentRow, index) in getProductComponents(
                props.rowData
              )"
              :key="`${props.rowData.id}-${index}`"
            >
              {{ componentRow.name }} — {{ formatQty(componentRow.qty) }} шт
            </li>
          </ul>
          <span v-else>—</span>
        </template>
        <template slot="reserved" slot-scope="props">
          <span v-if="props.rowData.reserved" class="badge badge-warning"
            >Зарезервировано</span
          >
          <span v-else class="badge badge-success">Свободно</span>
        </template>
      </va-data-table>
    </div>
    <div class="mt-4 text-center">
      <va-button
        v-if="canEditOrder"
        color="warning"
        class="mr-2 mb-2"
        type="button"
        :to="{ name: 'order-edit', params: { id: orderInfo.id } }"
      >
        <va-icon name="fa fa-edit" class="mr-2" />
        Изменить заказ
      </va-button>
      <va-button
        type="button"
        color="success"
        class="mr-2"
        @click="downloadPDF"
      >
        <va-icon name="fa fa-download" class="mr-2" />
        Скачать PDF
      </va-button>
      <va-button type="button" color="info" class="mr-2" @click="printPDF">
        <va-icon name="fa fa-print" class="mr-2" />
        Печать PDF
      </va-button>
      <va-button type="button" color="primary" @click="$emit('hide', false)">
        Закрыть
      </va-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";

const EDITABLE_ORDER_STATUSES = [
  "new",
  "in_work",
  "assembling",
  "ready",
  "in_delivery",
];

const PAYMENT_LABELS = {
  pending_payment: "Не оплачен",
  waiting_for_paid_confirmation: "Ожидает подтверждения",
  paid: "Оплачен",
  refunding: "Возврат",
  refunded: "Возвращён",
};

const ORDER_LABELS = {
  new: "Новый",
  in_work: "В работе",
  assembling: "Собирается",
  ready: "Готов (самовывоз)",
  in_delivery: "Передан курьеру",
  completed: "Завершён",
  cancelled: "Отменён",
};

export default {
  props: {
    orderInfo: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  computed: {
    hasDimensionalStatus() {
      return !!(this.orderInfo && (this.orderInfo.order_status != null ||
        this.orderInfo.payment_status != null));
    },
    canEditOrder() {
      const o = this.orderInfo && this.orderInfo.order_status;
      const fallback = this.orderInfo && this.orderInfo.status;
      const os = o != null ? o : fallback;
      return !!os && EDITABLE_ORDER_STATUSES.includes(os);
    },
    orderStatus() {
      return this.orderStatusHandler();
    },
    fulfillmentSummary() {
      const raw = this.orderInfo && this.orderInfo.order_status;
      if (!raw) return "—";
      return ORDER_LABELS[raw] || raw;
    },
    paymentSummary() {
      const raw = this.orderInfo && this.orderInfo.payment_status;
      if (!raw) return "—";
      return PAYMENT_LABELS[raw] || raw;
    },
    orderComment() {
      const note = this.orderInfo && (this.orderInfo.notes || this.orderInfo.comment);
      if (note == null) return "";
      return String(note).trim();
    },
    staffComment() {
      if (!this.orderInfo) return "";
      if (!Object.prototype.hasOwnProperty.call(this.orderInfo, "staff_comment")) {
        return "";
      }
      const comment = this.orderInfo.staff_comment;
      if (comment == null) return "";
      return String(comment).trim();
    },
    productFields() {
      return [
        {
          name: "__slot:product_name",
          title: "Название товара",
        },
        {
          name: "__slot:qty",
          title: "Количество",
        },
        {
          name: "__slot:components",
          title: "Компоненты",
        },
        {
          name: "__slot:reserved",
          title: "Статус",
        },
      ];
    },
    // Сумма без скидки
    totalBefore() {
      // Используем total_before, если есть (новая система)
      if (
        this.orderInfo.total_before !== null &&
        this.orderInfo.total_before !== undefined
      ) {
        return this.orderInfo.total_before;
      }
      // Иначе считаем: товары + доставка
      const amountProducts = this.orderInfo.amount_products || 0;
      const amountDelivery = this.orderInfo.amount_delivery || 0;
      return amountProducts + amountDelivery;
    },
    // Размер скидки
    discountAmount() {
      return this.orderInfo.discount_amount || 0;
    },
    // Есть ли скидка
    hasDiscount() {
      return this.discountAmount > 0;
    },
    // Сумма со скидкой
    totalAfter() {
      // Используем total_after, если есть (новая система)
      if (
        this.orderInfo.total_after !== null &&
        this.orderInfo.total_after !== undefined
      ) {
        return this.orderInfo.total_after;
      }
      // Используем total_discounted_amount (accessor из модели)
      if (
        this.orderInfo.total_discounted_amount !== null &&
        this.orderInfo.total_discounted_amount !== undefined
      ) {
        return this.orderInfo.total_discounted_amount;
      }
      // Fallback: считаем вручную
      return this.totalBefore - this.discountAmount;
    },
  },
  methods: {
    formatOmskDateTime(dateString) {
      if (!dateString) return "—";
      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) return "—";
      const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Omsk",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).formatToParts(date);
      const v = (type) => parts.find((p) => p.type === type)?.value || "";
      const d = v("day");
      const m = v("month");
      const y = v("year");
      const h = v("hour");
      const min = v("minute");
      return `${d} - ${m} - ${y}, ${h}:${min}`;
    },
    formatPreviewDate(raw) {
      if (raw == null || raw === "") return "—";
      const s = String(raw).trim();
      // Только календарная дата из API (Y-m-d) — без сдвига из‑за UTC.
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        const [y, m, d] = s.split("-");
        return `${d} - ${m} - ${y}`;
      }
      const date = new Date(s);
      if (Number.isNaN(date.getTime())) return "—";
      // ISO с временем (Z): брать календарный день в зоне приложения, как в таблице заказов.
      const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Omsk",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).formatToParts(date);
      const part = (type) => parts.find((p) => p.type === type)?.value || "";
      return `${part("day")} - ${part("month")} - ${part("year")}`;
    },
    orderStatusHandler() {
      const status = this.orderInfo.status;
      if (ORDER_LABELS[status]) {
        return ORDER_LABELS[status];
      }
      if (status === "pending" || status === "pending_payment") return "Ожидает оплаты";
      if (status === "in_delivery") return "Передано курьеру";
      if (status === "paid") return "В работе (устаревшая метка)";
      if (status === "completed") return "Завершён";
      if (status === "pickup") return "Готов к выдаче";
      if (status === "rejected") return "Отклонено";
      if (status === "waiting_for_paid_confirmation")
        return "Ожидает подтверждения оплаты";
      return status || "—";
    },
    formatPrice(amount) {
      if (amount === null || amount === undefined) return "—";
      return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount);
    },
    formatQty(value) {
      const qty = Number(value);
      if (!Number.isFinite(qty)) {
        return "0";
      }
      if (Math.abs(qty - Math.round(qty)) < 0.00001) {
        return String(Math.round(qty));
      }
      return qty.toFixed(2).replace(/\.?0+$/, "");
    },
    getProductComponents(orderProduct) {
      const orderQty = Math.max(0, Number(orderProduct?.qty || 0));
      const product = orderProduct?.product;
      const bundleComponents = Array.isArray(product?.bundle_components)
        ? product.bundle_components
        : [];

      const components = bundleComponents
        .map((bundleComponent) => {
          const componentQty =
            Number(bundleComponent?.quantity || 0) * orderQty;
          if (componentQty <= 0) return null;

          const componentName = (
            bundleComponent?.component_product?.name || ""
          ).trim();
          return {
            name:
              componentName ||
              `Компонент #${
                bundleComponent?.component_product_id !== undefined
                  ? bundleComponent.component_product_id
                  : "—"
              }`,
            qty: componentQty,
          };
        })
        .filter(Boolean);

      if (components.length === 0 && orderQty > 0) {
        const fallbackName = (product?.name || "").trim();
        components.push({
          name:
            fallbackName ||
            `Товар #${
              product?.id !== undefined ? product.id : orderProduct?.id
            }`,
          qty: orderQty,
        });
      }

      return components;
    },
    async downloadPdfByEndpoint(endpoint, fileName) {
      const response = await api.get(endpoint, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    async printPdfByEndpoint(endpoint, errorPrefix) {
      let url;

      try {
        const response = await api.get(endpoint, {
          responseType: "blob",
        });

        url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.src = url;

        let cleaned = false;
        let fallbackCleanupTimer;

        const cleanup = () => {
          if (cleaned) return;
          cleaned = true;
          if (fallbackCleanupTimer) {
            clearTimeout(fallbackCleanupTimer);
          }
          iframe.remove();
          if (url) {
            window.URL.revokeObjectURL(url);
            url = null;
          }
        };

        iframe.onload = () => {
          try {
            const printWindow = iframe.contentWindow;
            if (printWindow) {
              printWindow.onafterprint = cleanup;
            }
            // Увеличили fallback, чтобы диалог печати не закрывался "слишком рано" в медленных окружениях.
            fallbackCleanupTimer = setTimeout(cleanup, 120000);
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
          } catch (printError) {
            cleanup();
            throw printError;
          }
        };

        document.body.appendChild(iframe);
      } catch (error) {
        if (url) {
          window.URL.revokeObjectURL(url);
        }

        console.error(`${errorPrefix}:`, error);
        alert(
          `${errorPrefix}: ` +
            (error.response?.data?.message || error.message)
        );
      }
    },
    async downloadPDF() {
      try {
        await this.downloadPdfByEndpoint(
          `/admin/orders/${this.orderInfo.id}/pdf`,
          `Заказ_${this.orderInfo.id}.pdf`
        );
      } catch (error) {
        console.error("Ошибка при генерации PDF:", error);
        alert(
          "Произошла ошибка при генерации PDF: " +
            (error.response?.data?.message || error.message)
        );
      }
    },
    async printPDF() {
      await this.printPdfByEndpoint(
        `/admin/orders/${this.orderInfo.id}/pdf`,
        "Произошла ошибка при печати PDF"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.badge {
  display: inline-block;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  &-warning {
    background-color: #f2f236;
    color: #000;
  }
  &-success {
    background-color: #4bb543;
    color: #fff;
  }
}

.total-after-input {
  font-weight: 600;
}

.order-status-blocks {
  padding: 0.75rem 0.65rem;
  margin-bottom: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.02);

  &__heading {
    margin: 0 0 0.5rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.72);
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
}

.components-list {
  margin: 0;
  padding-left: 18px;
}
</style>
